import { createContext } from 'react';

export const ChangelogContext = createContext<
  | {
      canEdit: boolean;
      changelogItems: ChangelogItem[];
      deleteChangelogItem: (_id: ChangelogItem['id']) => void;
      fetchMoreChangelogItems: () => void;
      hasLoaded: boolean;
      hasMore: boolean;
      updateChangelogItem: (_id: ChangelogItem['id'], _description: ChangelogItem['description']) => void;
    }
  | undefined
>(undefined);
